import { countriesActions } from "../../actionTypes";

const initialState = {
	countries: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case countriesActions.FETCH_COUNTRIES: {
			return { ...state, fetching: true };
		}

		case countriesActions.FETCH_COUNTRIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				countries: action.payload,
			};
		}

		case countriesActions.FETCH_COUNTRIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};
export default Reducer;
